import type React from "react";
import type TextAreaProps from "./TextArea.model";
import { StyledTextArea } from "./TextArea.styled";

export const TextArea: React.FC<TextAreaProps> = ({ dataCy, ...props }) => (
  <StyledTextArea data-cy={dataCy} {...props} />
);

export default TextArea;
